import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import FixedDate from './Date/FixedDate';
import RecurrenceDate from './Date/RecurrenceDate';
import LiveInDate from './Date/LiveInDate';

const EventDate = (props) => {
  const eventType = props.eventType;

  if (eventType === 'FIXED_EVENT') {
    return (
      <FixedDate
        {...props}
      />
    );
  } else if (eventType === 'RECURRENCE_EVENT') {
    return (
      <RecurrenceDate
        {...props}
      />
    );
  } else if (eventType === 'LIVEIN_EVENT') {
    return (
      <LiveInDate
        {...props}
      />
    );
  }
  return null;
};

EventDate.propTypes = {
  eventType: PropTypes.oneOf(['RECURRENCE_EVENT', 'FIXED_EVENT', 'LIVEIN_EVENT']),
  setEventType: PropTypes.func.isRequired,
  setIsStepValid: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired,
  newEvent: PropTypes.object.isRequired,
  updateEventData: PropTypes.func.isRequired,
  updateRecurrenceData: PropTypes.func.isRequired,
  updateLiveInData: PropTypes.func.isRequired,
  updateBreakDetails: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
});
export default connect(mapStateToProps, dispatch)(React.memo(EventDate));
